import { autocompleteClasses } from '@mui/material'
import { alpha, createTheme } from '@mui/material/styles'
import { palette } from './palette'
import { typography } from './typography'

export const theme = createTheme({
  typography,
  breakpoints: {
    values: {
      xs: 0,
      sm: 457,
      md: 624,
      lg: 824,
      xl: 1200
    }
  },
  palette,
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        disableElevation: true
      },
      styleOverrides: {
        root: {
          paddingLeft: 24,
          paddingRight: 24,
          height: 54,
          borderRadius: 27,
          textTransform: 'unset',
          fontSize: 16,
          fontWeight: 600,
          fontFamily: 'Inter'
        },
        outlinedPrimary: ({ theme }) => ({
          borderColor: theme.palette.primary.main,
          borderWidth: 1,
          ':hover': {
            borderWidth: 1
          }
        }),
        sizeSmall: {
          height: 40,
          fontSize: 14
        }
      },
      variants: [
        {
          props: { variant: 'solid' },
          style: {
            backgroundColor: palette.members.button.primary,
            letterSpacing: '-0.01em',
            fontSize: '0.9375rem',
            fontWeight: 500,
            color: 'white',
            '&:hover': {
              backgroundColor: palette.members.button.hover
            },
            '&:disabled': {
              backgroundColor: alpha(palette.primary.main, 0.6),
              color: 'white'
            },
            '.MuiButton-endIcon': {
              position: 'absolute',
              fontSize: '1rem',
              right: '1.25rem',
              '& > *:nth-of-type(1)': { fontSize: '1rem' }
            }
          }
        },
        {
          props: { variant: 'outlinedAlt' },
          style: {
            borderColor: palette.members.stroke,
            backgroundColor: 'white',
            letterSpacing: '-0.02em',
            padding: '0.5rem 1rem',
            borderStyle: 'solid',
            borderWidth: '1px',
            lineHeight: 1.4,
            fontWeight: 500,
            color: '#555555',
            '&:hover': {
              backgroundColor: palette.members.input.hover
            },
            '.MuiButton-endIcon': {
              position: 'absolute',
              fontSize: '1rem',
              right: '1.25rem',
              '& > *:nth-of-type(1)': { fontSize: '1rem' }
            }
          }
        }
      ]
    },
    MuiLinearProgress: {
      styleOverrides: {
        barColorPrimary: ({ theme }) => ({ background: theme.palette.brandPrimary.light.main }),
        colorPrimary: ({ theme }) => ({ background: theme.palette.brandGrey.light })
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: '0 0 16px'
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          background: theme.palette.background.paper
        })
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.background.paper
        })
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: ({ theme }) => ({
          [`& .${autocompleteClasses.option}.${autocompleteClasses.focused}`]: {
            backgroundColor: `${theme.palette.brandGrey.light}`
          }
        })
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body3: 'p',
          title: 'h1'
        }
      },
      variants: [
        {
          props: { variant: 'label' },
          style: {
            letterSpacing: '-0.02em',
            fontSize: '0.9375rem',
            fontWeight: 500
          }
        },
        {
          props: { variant: 'body3' },
          style: {
            color: palette.members.primary,
            letterSpacing: '-0.02em',
            fontSize: '0.875rem',
            fontWeight: 400
          }
        },
        {
          props: { variant: 'subtitle3' },
          style: {
            color: palette.members.primary,
            fontSize: '0.75rem',
            lineHeight: '1.65',
            fontWeight: 400
          }
        },
        {
          props: { variant: 'title' },
          style: ({ theme }) => ({
            fontFamily: 'CanelaMedium',
            color: palette.members.primary,
            fontSize: '1.125rem',
            lineHeight: '1.3',
            fontWeight: 500,
            [theme.breakpoints.up('sm')]: {
              fontSize: '1.7rem'
            }
          })
        },
        {
          props: { variant: 'titleHighlight' },
          style: {
            fontFamily: 'CanelaRegularItalic',
            fontSize: 'inherit',
            fontWeight: 600
          }
        }
      ]
    }
  }
})
